import {
  Http
} from '@/model/Http.js'

export default class activation extends Http {
    getPackageList(data){
      const url ='api/package/list'
      return this.postAjax(url,{
          ...data
      })
    }
}



// WEBPACK FOOTER //
// ./src/javaApi/activation.js